export default __webpack_public_path__ + "static/media/ghost-deer.07c81cb1.png";